import React, { useEffect } from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { DateRangePicker, DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';
import AdapterJalali from '@date-io/date-fns-jalali';
import TextField from '@mui/material/TextField';
import { useState } from 'react';
import moment from 'moment-jalaali';

const Filters = ({ states, setStates, search }) => {

    const [value, setValue] = useState([null, null]);
    const getMaxDate = (date) => {
        if (!date) {
            return date
        }
        const startTime = new Date(date).getTime()
        const month = date.getMonth();
        const year = date.getFullYear();
        let daysInMonth = new Date(year, month, 0).getDate();
        daysInMonth = daysInMonth + 96
        return new Date(startTime + daysInMonth * 24 * 60 * 60 * 1000)
    }

    const maxDate = React.useMemo(() => getMaxDate(value[0]), [value])


    useEffect(() => {
        if (value && value[0]) {
            const sDate = moment(new Date(value[0])).format('YYYY-MM-DD')
            setStates({ sDate })
        } else {
            setStates({ sDate: '' })
        }

        if (value && value[1]) {
            const eDate = moment(new Date(value[1])).format('YYYY-MM-DD')
            setStates({ eDate })
        } else {
            setStates({ eDate: '' })
        }
    }, [value])
    return (
        <div className='row'>
            <div className='col-lg-10'>
                <div className='row'>
                    <div className='col-lg-3'>

                        <div className='custom-select'>
                            <select className='form-control custom'
                                value={states.user}
                                onChange={(e) => { setStates({ user: e.target.value }) }}
                            >
                                <option value={''} >انتخاب کاربر</option>
                                {states.users?.filter(i => i.name !== null).map((user, idx) => <option key={idx} value={user.userId} >{user.fullName}</option>)}

                            </select>
                        </div>
                    </div>
                    {/* <div className='col-lg-3'>

                        <div className='custom-select'>
                            <select className='form-control custom'
                                value={states.actionType}
                                onChange={(e) => { setStates({ actionType: e.target.value }) }}
                            >
                                {states.entities?.map((en, idx) => <option key={idx} value={en.value} >{en.name}</option>)}
                                <option value="Added">اضافه کردن</option>
                                <option value="Modified">تغییر دادن</option>
                                <option value="Deleted">حذف کردن</option>

                            </select>
                        </div>
                    </div> */}
                    <div className='col-lg-6'>

                        <LocalizationProvider
                            dateAdapter={AdapterJalali}
                            localeText={{ start: 'ازتاریخ', end: 'تا تاریخ' }}
                        >
                            <DateRangePicker
                                startText="از تاریخ"
                                endText="تا تاریخ"
                                maxDate={maxDate}
                                value={value}
                                onChange={(newValue) => {
                                    setValue(newValue);
                                }}
                                renderInput={(startProps, endProps) => (
                                    <React.Fragment>
                                        <TextField {...startProps} />
                                        <span style={{ margin: '0px 10px' }}>تا</span>
                                        {/* <DateRangeDelimiter> to </DateRangeDelimiter>  */}
                                        <TextField {...endProps} />
                                    </React.Fragment>
                                )}
                            />
                        </LocalizationProvider>
                    </div>

                </div>
            </div>

        </div>
    )
}

export default Filters
